import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M34.0918 20.0381H55.1621L38.1162 32.4229L44.627 52.4619L27.5811 40.0771L10.5352 52.4619L17.0459 32.4229L0 20.0381H21.0703L27.5811 0L34.0918 20.0381ZM23.9766 24.0381H12.3105L21.748 30.8955L18.1436 41.9883L27.5811 35.1328L37.0176 41.9883L33.4141 30.8955L42.8516 24.0381H31.1855L27.5811 12.9434L23.9766 24.0381Z'
const RAW_WIDTH = 55.16
const RAW_HEIGHT = 52.46

/**
 * Star cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */

export const StarCutoutShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default StarCutoutShape
